import { useState, useEffect } from "react";
import _ from "lodash";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { HeaderBack } from '@/components/common/header';
import Redux, { updatePath } from "@/action";
import { PopularCarBrands } from "@/components/vehicle";
import { toast } from "@/libraries/swal";
import { useRouter } from "next/router";
import { pageLink } from "@/config/site";
import { VehicleBrandModal, VehicleModelModal, VehicleVariantModal } from "../../components/modal";
import { _getAllVehicleBrandList, _getAllVehicleModelList, _getAllVehicleVariant, _modelName, _getAllVehicleTopList } from "../../libraries/common";
import { VehicleImage } from "@/components/common/image";
import { BottomNavigation } from "../../components/common/navigation";
import { Footer } from "../../components/common/footer";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from "../../components/body/body";

const vehicleSeries = [
    {id: 1, text: "Popular"},
    {id: 2, text: "Sedan"},
    {id: 3, text: "SUV"},
    {id: 4, text: "MPV"},
    {id: 5, text: "Hatchback"},
]

export default function Index(props) {
    const { t, device, session } = props;
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true);

    // compare
    const router = useRouter()
    const [redVehicleModel, setRedVehicleModel] = useState({})
    const [blueVehicleModel, setBlueVehicleModel] = useState({})
    const [openVehicleModal, setOpenVehicleModal] = useState(0) // 0 = red, 1 = blue

    // vehicle brand moal
    const [vehicleBrandModalOpen, setVehicleBrandModalOpen] = useState(false)
    const [vehicleBrandImage, setVehicleBrandImage] = useState(null)

    // vehicle model modal
    const [vehicleModelModalOpen, setVehicleModelModalOpen] = useState(false)
    const [vehicleModelData, setVehicleModelData] = useState([]) // model list by brand
    const [vehicleModelActive, setVehicleModelActive] = useState({})
    const [vehicleModelLoading, setVehicleModelLoading] = useState(false)

    // vehicle variant modal
    const [vehicleVariantModalOpen, setVehicleVariantModalOpen] = useState(false)
    const [vehicleVariantData, setVehicleVariantData] = useState({}) // variant list by model
    const [vehicleVariantLoading, setVehicleVaraintLoading] = useState(false)

    const _handleClickBrandItem = async(value) => { 
        try {
            //  get all model list under vehicle brand id
            setVehicleModelModalOpen(true)
            setVehicleModelLoading(true)
            setVehicleBrandImage(value?.image_path)
            await _getAllVehicleModelList(setVehicleModelData, {
                vehicleBrandId: value?.vehicle_brand_id
            });
            setVehicleModelLoading(false)
        } catch(error) {
            console.log(error)
        }
    }

    const _handleClickModelItem = async(value) => {
        try {
            setVehicleVaraintLoading(true)
            setVehicleVariantModalOpen(true)
            setVehicleModelActive({image_path: value.image_path, brand_name: value.brand_name, model_name: _modelName(value.brand_name, value.name)})
            await _getAllVehicleVariant(setVehicleVariantData, {
                vehicle_model_id: value.vehicle_model_id
            })
            setVehicleVaraintLoading(false)
        } catch(error) {
            console.log(error)
        }
    }

    const _handleClickVariantItem = async(value) => {
        try {
            // each vehicle 1 not empty, new vehicle selected will go compare result page
            if((!_.isEmpty(redVehicleModel) && !_.isEmpty(value) && openVehicleModal != 0) || (!_.isEmpty(blueVehicleModel) && !_.isEmpty(value) && openVehicleModal != 1)){
                if(openVehicleModal == 0){
                    await router.push(`${pageLink.compare.compareMidUrl}${value?.compare_custom_url}-vs-${blueVehicleModel?.compare_custom_url}?v1=${value?.variant_id}&v2=${blueVehicleModel?.variant_id}`);
                }else {
                    await router.push(`${pageLink.compare.compareMidUrl}${redVehicleModel?.compare_custom_url}-vs-${value?.compare_custom_url}?v1=${redVehicleModel?.variant_id}&v2=${value?.variant_id}`);
                }
                return; // after come here stop below all function
            }

            if(openVehicleModal == 0){
                setRedVehicleModel(value)
            } else {
                setBlueVehicleModel(value)
            }
            setVehicleBrandModalOpen(false)
            setVehicleModelModalOpen(false)
            setVehicleVariantModalOpen(false)
        } catch(error) {
            toast.error(error)
        }
    }

    useEffect(()=>{
        const fetchData = async()=>{
            try{
                //  get all brand list
                if(_.isEmpty(store?.path?.dataAllVehicleBrandList)){
                    await _getAllVehicleBrandList(dispatch);
                }
                if(store?.path?.dataAllVehicleTopList == undefined){
                    await _getAllVehicleTopList(dispatch);
                }
            } catch(error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
            
        }
        fetchData()
    },[])

    return (
        <>
            <AllMeta
                title={t('comparePage_meta_title')}
                description={t('comparePage_meta_description')}
                keyword={t('comparePage_meta_keyword')}
            />
            <Head><title>{t('comparePage_title')}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack t={t} />
                }
                navigationComponent={
                    <BottomNavigation t={t} />
                }
                showNavigation={false}
                modalComponent={
                    <>
                        <VehicleBrandModal 
                            t={t}
                            vehicleBrandModalOpen={vehicleBrandModalOpen}
                            setVehicleBrandModalOpen={setVehicleBrandModalOpen}
                            handleClickBrandItem={_handleClickBrandItem}
                            vehicleBrandData={store?.path?.dataAllVehicleBrandList ?? []}
                            isMultipleModal={true}
                        />
                        <VehicleModelModal 
                            t={t}
                            vehicleModelModalOpen={vehicleModelModalOpen}
                            setVehicleModelModalOpen={setVehicleModelModalOpen}
                            handleClickModelItem={_handleClickModelItem}
                            vehicleModelData={vehicleModelData}
                            vehicleBrandImage={vehicleBrandImage}
                            isMultipleModal={true}
                            loading={vehicleModelLoading}
                        />
                        <VehicleVariantModal 
                            t={t}
                            vehicleVariantModalOpen={vehicleVariantModalOpen}
                            setVehicleVariantModalOpen={setVehicleVariantModalOpen}
                            handleClickVariantItem={_handleClickVariantItem}
                            vehicleVariantData={vehicleVariantData}
                            vehicleModelActive={vehicleModelActive}
                            isActiveVaraintList={_.compact(_.map([redVehicleModel, blueVehicleModel], (value) => value.variant_id))}
                            isMultipleModal={true}
                            loading={vehicleVariantLoading}
                        />
                    </>
                }
            >
                <>
                    <div className="compareVehicle containerPadding">
                        <p className="fontSize_16 fontWeight_bold">
                            {t('compare_car_model')}
                        </p>
                        <div className="compareVehicle_vsContainer">
                            <div className="compareVehicle_vsContainer_text">
                                <p className="fontSize_20 fontWeight_extraBold fontColor_red fontStyle_italic compareVehicle_vsContainer_text_v">
                                    V
                                </p>
                                <p className="fontSize_20 fontWeight_extraBold fontColor_lightBlue2 fontStyle_italic compareVehicle_vsContainer_text_s">
                                    S
                                </p>
                            </div>
                            {/* make image reverse class name compareVehicle_vsContainer_boxInner_imageOuterReverse */}
                            <div className="compareVehicle_vsContainer_box compareVehicle_vsContainer_vBox">
                                <div className="compareVehicle_vsContainer_boxInner">
                                    {
                                        !_.isEmpty(redVehicleModel) ?
                                        <>
                                            <div className="compareVehicle_vsContainer_boxInner_title_v">
                                                <p className="fontSize_12 fontWeight_medium compareVehicle_vsContainer_boxInner_title">
                                                    {redVehicleModel?.name}
                                                </p>
                                            </div>
                                            <div className="compareVehicle_vsContainer_boxInner_image_v">
                                                <div className="compareVehicle_vsContainer_boxInner_imageOuter">
                                                    <VehicleImage 
                                                        imagePath={redVehicleModel?.model_image_path}
                                                    />
                                                    {/* <div className="compareVehicle_vsContainer_boxInner_image" style={{backgroundImage: `url(/assets/images/example/car_sample_transparent.png)`}} /> */}
                                                </div>
                                            </div>
                                            <div onClick={()=>{setRedVehicleModel({})}} className="compareVehicle_vsContainer_boxInner_button_v cursorPointer">
                                                <div className="compareVehicle_vsContainer_boxInner_button primaryButtonBackground">
                                                    <p className="fontSize_12 fontWeight_semiBold fontColor_white">
                                                        {t('clear')}
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <div onClick={()=>{setVehicleBrandModalOpen(true); setOpenVehicleModal(0)}} className="compareVehicle_vsContainer_boxEmpty compareVehicle_vsContainer_boxEmpty_left cursorPointer">
                                            <div className="plusIcon_size">
                                                <img 
                                                    className="w-100"
                                                    src={"/assets/images/plug_red_icon.svg"}
                                                />
                                            </div>
                                            <p className="fontSize_14 fontColor_red">
                                                {t('select_car')}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="compareVehicle_vsContainer_box compareVehicle_vsContainer_sBox">
                                <div className="compareVehicle_vsContainer_boxInner">
                                    {
                                        !_.isEmpty(blueVehicleModel) ?
                                        <>
                                            <div onClick={()=>{setBlueVehicleModel({})}} className="compareVehicle_vsContainer_boxInner_button_s cursorPointer">
                                                <div className="compareVehicle_vsContainer_boxInner_button secondaryButtonBackground">
                                                    <p className="fontSize_12 fontWeight_semiBold fontColor_darkBlue2">
                                                        {t('clear')}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="compareVehicle_vsContainer_boxInner_image_s">
                                                <div className="compareVehicle_vsContainer_boxInner_imageOuter">
                                                    <VehicleImage 
                                                        imagePath={blueVehicleModel?.model_image_path}
                                                    />
                                                </div>
                                            </div>
                                            <div className="compareVehicle_vsContainer_boxInner_title_s">
                                                <p className="fontSize_12 fontWeight_medium compareVehicle_vsContainer_boxInner_title">
                                                    {blueVehicleModel?.name}
                                                </p>
                                            </div>
                                        </>
                                        :
                                        <div onClick={()=>{setVehicleBrandModalOpen(true); setOpenVehicleModal(1)}}  className="compareVehicle_vsContainer_boxEmpty compareVehicle_vsContainer_boxEmpty_right cursorPointer">
                                            <div className="plusIcon_size">
                                                <img 
                                                    className="w-100"
                                                    src={"/assets/images/plug_lightBlue_icon.svg"}
                                                />
                                            </div>
                                            <p className="fontSize_14 fontColor_lightBlue">
                                                {t('select_car')}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        !_.isEmpty(store?.path?.dataAllVehicleTopList) &&
                        <div className="comparePopularCarMargin">
                            <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
                        </div>
                    }
                </>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('comparePage_meta_title')}
    //             description={t('comparePage_meta_description')}
    //             keyword={t('comparePage_meta_keyword')}
    //         />
    //         <Head><title>{t('comparePage_title')}</title></Head>
    //         <div className='bodyContainer' style={store?.path?.isLoadedInFlutterApp == true ? {paddingTop: 'unset'}: {}}>
    //             <div className={`contentContainer ${store?.path?.isLoadedInFlutterApp == false && 'bodyContainerHasBottomNavigation'}`}>
    //                 {
    //                     store?.path?.isLoadedInFlutterApp == false &&
    //                     <HeaderBack t={t} />
    //                 }
    //                 <div className="compareVehicle containerPadding">
    //                     <p className="fontSize_16 fontWeight_bold">
    //                         {t('compare_car_model')}
    //                     </p>
    //                     <div className="compareVehicle_vsContainer">
    //                         <div className="compareVehicle_vsContainer_text">
    //                             <p className="fontSize_20 fontWeight_extraBold fontColor_red fontStyle_italic compareVehicle_vsContainer_text_v">
    //                                 V
    //                             </p>
    //                             <p className="fontSize_20 fontWeight_extraBold fontColor_lightBlue2 fontStyle_italic compareVehicle_vsContainer_text_s">
    //                                 S
    //                             </p>
    //                         </div>
    //                         {/* make image reverse class name compareVehicle_vsContainer_boxInner_imageOuterReverse */}
    //                         <div className="compareVehicle_vsContainer_box compareVehicle_vsContainer_vBox">
    //                             <div className="compareVehicle_vsContainer_boxInner">
    //                                 {
    //                                     !_.isEmpty(redVehicleModel) ?
    //                                     <>
    //                                         <div className="compareVehicle_vsContainer_boxInner_title_v">
    //                                             <p className="fontSize_12 fontWeight_medium compareVehicle_vsContainer_boxInner_title">
    //                                                 {redVehicleModel?.name}
    //                                             </p>
    //                                         </div>
    //                                         <div className="compareVehicle_vsContainer_boxInner_image_v">
    //                                             <div className="compareVehicle_vsContainer_boxInner_imageOuter">
    //                                                 <VehicleImage 
    //                                                     imagePath={redVehicleModel?.model_image_path}
    //                                                 />
    //                                                 {/* <div className="compareVehicle_vsContainer_boxInner_image" style={{backgroundImage: `url(/assets/images/example/car_sample_transparent.png)`}} /> */}
    //                                             </div>
    //                                         </div>
    //                                         <div onClick={()=>{setRedVehicleModel({})}} className="compareVehicle_vsContainer_boxInner_button_v cursorPointer">
    //                                             <div className="compareVehicle_vsContainer_boxInner_button primaryButtonBackground">
    //                                                 <p className="fontSize_12 fontWeight_semiBold fontColor_white">
    //                                                     {t('clear')}
    //                                                 </p>
    //                                             </div>
    //                                         </div>
    //                                     </>
    //                                     :
    //                                     <div onClick={()=>{setVehicleBrandModalOpen(true); setOpenVehicleModal(0)}} className="compareVehicle_vsContainer_boxEmpty compareVehicle_vsContainer_boxEmpty_left cursorPointer">
    //                                         <div className="plusIcon_size">
    //                                             <img 
    //                                                 className="w-100"
    //                                                 src={"/assets/images/plug_red_icon.svg"}
    //                                             />
    //                                         </div>
    //                                         <p className="fontSize_14 fontColor_red">
    //                                             {t('select_car')}
    //                                         </p>
    //                                     </div>
    //                                 }
    //                             </div>
    //                         </div>
    //                         <div className="compareVehicle_vsContainer_box compareVehicle_vsContainer_sBox">
    //                             <div className="compareVehicle_vsContainer_boxInner">
    //                                 {
    //                                     !_.isEmpty(blueVehicleModel) ?
    //                                     <>
    //                                         <div onClick={()=>{setBlueVehicleModel({})}} className="compareVehicle_vsContainer_boxInner_button_s cursorPointer">
    //                                             <div className="compareVehicle_vsContainer_boxInner_button secondaryButtonBackground">
    //                                                 <p className="fontSize_12 fontWeight_semiBold fontColor_darkBlue2">
    //                                                     {t('clear')}
    //                                                 </p>
    //                                             </div>
    //                                         </div>
    //                                         <div className="compareVehicle_vsContainer_boxInner_image_s">
    //                                             <div className="compareVehicle_vsContainer_boxInner_imageOuter">
    //                                                 <VehicleImage 
    //                                                     imagePath={blueVehicleModel?.model_image_path}
    //                                                 />
    //                                             </div>
    //                                         </div>
    //                                         <div className="compareVehicle_vsContainer_boxInner_title_s">
    //                                             <p className="fontSize_12 fontWeight_medium compareVehicle_vsContainer_boxInner_title">
    //                                                 {blueVehicleModel?.name}
    //                                             </p>
    //                                         </div>
    //                                     </>
    //                                     :
    //                                     <div onClick={()=>{setVehicleBrandModalOpen(true); setOpenVehicleModal(1)}}  className="compareVehicle_vsContainer_boxEmpty compareVehicle_vsContainer_boxEmpty_right cursorPointer">
    //                                         <div className="plusIcon_size">
    //                                             <img 
    //                                                 className="w-100"
    //                                                 src={"/assets/images/plug_lightBlue_icon.svg"}
    //                                             />
    //                                         </div>
    //                                         <p className="fontSize_14 fontColor_lightBlue">
    //                                             {t('select_car')}
    //                                         </p>
    //                                     </div>
    //                                 }
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 {/* <div className="compareVehicle_popular">
    //                     <div className="containerPadding">
    //                         <p className="fontSize_16 fontWeight_bold">
    //                             Comparison of Popular Cars
    //                         </p>
    //                     </div>
    //                     <CommonCategory 
    //                         data={vehicleSeries}
    //                         activeCategory={activeCategory}
    //                         setActiveCategory={setActiveCategory}
    //                         t={t}
    //                         isAllAllow={false}
    //                     />
    //                     <ScrollContainer
    //                         className="compareVehicle_popularContainer"
    //                     >
    //                         <div className="compareVehicle_popularWrap containerPadding">
    //                             {
    //                                 _.reduce([1,2,3,4,5], (result, value, key)=>{
    //                                     result.push(
    //                                         <div key={key} className="compareVehicle_popularItem">
    //                                             <div className="compareVehicle_popularItem_vs">
    //                                                 <p className="fontSize_20 fontWeight_extraBold fontColor_red fontStyle_italic compareVehicle_popularItem_vs_v">
    //                                                     V
    //                                                 </p>
    //                                                 <p className="fontSize_20 fontWeight_extraBold fontColor_lightBlue2 fontStyle_italic compareVehicle_popularItem_vs_s">
    //                                                     S
    //                                                 </p>
    //                                             </div>
    //                                             <div className="compareVehicle_popularItem_row">
    //                                                 <div className="compareVehicle_popularItem_row_left">
    //                                                     <p className="fontSize_12 fontWeight_medium">
    //                                                         2022 Tank 300 1.5 Turbo
    //                                                     </p>
    //                                                 </div>
    //                                                 <div className="compareVehicle_popularItem_row_right">
    //                                                     <p className="fontSize_12 fontWeight_medium">
    //                                                         2022 Tank 300 1.5 Turbo
    //                                                     </p>
    //                                                 </div>
    //                                             </div>
    //                                             <div className="compareVehicle_popularItem_row">
    //                                                 <div className="compareVehicle_popularItem_row_left">
    //                                                     <div className="compareVehicle_popularItem_imageOuter">
    //                                                         <div className="compareVehicle_popularItem_image" style={{backgroundImage: `url(/assets/images/example/car_sample_transparent.png)`}} />
    //                                                     </div>
    //                                                 </div>
    //                                                 <div className="compareVehicle_popularItem_row_right">
    //                                                     <div className="compareVehicle_popularItem_imageOuter">
    //                                                         <div className="compareVehicle_popularItem_image" style={{backgroundImage: `url(/assets/images/example/car_sample_transparent.png)`}} />
    //                                                     </div> 
    //                                                 </div>
    //                                             </div>
    //                                             <div className="compareVehicle_popularItem_row">
    //                                                 <div className="compareVehicle_popularItem_row_left">
    //                                                     <p className="fontSize_12 fontWeight_semiBold fontColor_red">
    //                                                         RM279,200
    //                                                     </p>
    //                                                 </div>
    //                                                 <div className="compareVehicle_popularItem_row_right">
    //                                                     <p className="fontSize_12 fontWeight_semiBold fontColor_red">
    //                                                         RM279,200
    //                                                     </p>
    //                                                 </div>
    //                                             </div>
    //                                             <Link href={`${pageLink.compare.compareMidUrl}car-1-vs-car-2`}>
    //                                                 <div className="compareVehicle_popularItem_button cursorPointer">
    //                                                     <div className="compareVehicle_popularItem_button_box compareVehicle_popularItem_button_red primaryButtonBackground">
    //                                                         <p className="fontSize_12 fontWeight_semiBold fontColor_white">
    //                                                             Tank 300
    //                                                         </p>
    //                                                     </div>
    //                                                     <div className="compareVehicle_popularItem_button_box compareVehicle_popularItem_button_blue secondaryButtonBackground">
    //                                                         <p className="fontSize_12 fontWeight_semiBold fontColor_darkBlue2">
    //                                                             Tank 500
    //                                                         </p>
    //                                                     </div>
    //                                                 </div>
    //                                             </Link>
    //                                         </div>
    //                                     )
    //                                     return result
    //                                 },[])
    //                             }
    //                         </div>
    //                     </ScrollContainer>
    //                 </div> */}
    //                 {
    //                     !_.isEmpty(store?.path?.dataAllVehicleTopList) &&
    //                     <div className="comparePopularCarMargin">
    //                         <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
    //                     </div>
    //                 }
    //                 <Footer t={t} />
    //             </div>
    //             {
    //                 store?.path?.isLoadedInFlutterApp == false &&
    //                 <BottomNavigation t={t} />
    //             }
    //             <VehicleBrandModal 
    //                 t={t}
    //                 vehicleBrandModalOpen={vehicleBrandModalOpen}
    //                 setVehicleBrandModalOpen={setVehicleBrandModalOpen}
    //                 handleClickBrandItem={_handleClickBrandItem}
    //                 vehicleBrandData={store?.path?.dataAllVehicleBrandList ?? []}
    //                 isMultipleModal={true}
    //             />
    //             <VehicleModelModal 
    //                 t={t}
    //                 vehicleModelModalOpen={vehicleModelModalOpen}
    //                 setVehicleModelModalOpen={setVehicleModelModalOpen}
    //                 handleClickModelItem={_handleClickModelItem}
    //                 vehicleModelData={vehicleModelData}
    //                 vehicleBrandImage={vehicleBrandImage}
    //                 isMultipleModal={true}
    //                 loading={vehicleModelLoading}
    //             />
    //             <VehicleVariantModal 
    //                 t={t}
    //                 vehicleVariantModalOpen={vehicleVariantModalOpen}
    //                 setVehicleVariantModalOpen={setVehicleVariantModalOpen}
    //                 handleClickVariantItem={_handleClickVariantItem}
    //                 vehicleVariantData={vehicleVariantData}
    //                 vehicleModelActive={vehicleModelActive}
    //                 isActiveVaraintList={_.compact(_.map([redVehicleModel, blueVehicleModel], (value) => value.variant_id))}
    //                 isMultipleModal={true}
    //                 loading={vehicleVariantLoading}
    //             />
    //         </div>
    //     </>
    // )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
        ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}